import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { CoreService, CustomerUser } from '../services/core.service';
declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_customer_card_message_modal',
    templateUrl: './customer_card_message_modal.html',
})
export class CustomerCardMessageModal implements OnInit {
    constructor(public coreService: CoreService) {}

    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
    }
    Customer_Card_Message_Modal_Close() {
        $('#Customer_Card_Message_Modal').modal('hide');
    }
}
